export default __webpack_public_path__ + "static/media/ic_glp_avax.b9921f80.svg";